// Public gateway origin shown in copy-paste snippets (from openapi.yaml `servers`).
// Distinct from API_BASE: the SPA itself always calls the same-origin `/api` prefix.
export const GATEWAY_PUBLIC_URL: string =
  import.meta.env.VITE_GATEWAY_PUBLIC_URL ?? 'https://mcp.symone.com'

/** Per-workspace MCP endpoint, as configured in an MCP client's mcp.json. */
export function mcpEndpoint(workspaceId: string): string {
  return `${GATEWAY_PUBLIC_URL}/mcp/${workspaceId}`
}
